import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { FloatingButton as FloatingButtonMemoized } from '../FloatingButton/FloatingButton.js';
import { useSkipLink } from './useSkipLink.js';

/**
 * SkipLink is a button that allows users to skip to the main content of a page. It only appears when users tab through the page.
 */
var SkipLink = function SkipLink(props) {
  var _useSkipLink = useSkipLink(props),
    skipLinkProps = _useSkipLink.skipLinkProps,
    containerProps = _useSkipLink.containerProps;
  return /*#__PURE__*/React.createElement(Box, _extends({
    "data-testid": "skip-link-container"
  }, containerProps), /*#__PURE__*/React.createElement(FloatingButtonMemoized, _extends({
    "data-testid": "skip-link-button"
  }, skipLinkProps)));
};
SkipLink.displayName = 'SkipLink';

export { SkipLink };
//# sourceMappingURL=SkipLink.js.map
